import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dropfilter' })
export class DropfilterPipe implements PipeTransform {
  transform(categories: any, searchText: any): any {
    if(categories == null){
      return null;
    }
    if (searchText == null) return categories;

    return categories.filter(function (category) {
      //return category.service_provider_type_id.indexOf(searchText) > -1;
      return category.serviceprovidertype.toLowerCase().indexOf(searchText) === 0;
    })
  }
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/-pipe/drop_filter/drop_filter.pipe.ts